import React, { useEffect } from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import { getArticle } from "../../actions/articleActions";
import { connect } from "react-redux";

const ArticleRecommendationStyles = styled.div`
  .next-article {
    &__img {
      width: 100%;
      height: 275px;
      object-fit: cover;
    }

    &__list {
      width: 550px;
      margin-right: 60px;

      &-item {
        border-bottom: 2px solid var(--light-gray);
        padding-bottom: 32px;

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
          margin-bottom: 0;
          border-top: 2px solid var(--light-gray);
          margin-top: 28px;
        }

        &:nth-last-child(3) {
          border-bottom: none;
          padding-bottom: 0;
          margin-bottom: 0;
        }

        &:first-child {
          border-top: 2px solid var(--light-gray);
          margin-top: 30px;
        }
      }
    }

    &__item {
      &-header {
        padding-top: 30px;
        font-family: var(--header-font);
        font-size: 28px;
        line-height: 34px;
        margin-bottom: 16px;
      }

      &-desc {
        font-family: var(--body-font);
        font-size: 18px;
        line-height: 26px;
      }
    }
  }

  @media only screen and (max-width: 940px) {
    .next-article__img {
      height: 325px;
    }
  }
  @media only screen and (max-width: 700px) {
    .next-article__img {
      height: 250px;
    }
  }
`;

const ArticleRecommendation = ({
  header,
  id,
  articles: { article },
  getArticle,
}) => {
  useEffect(() => {
    //get article data from DB
    getArticle(id);
    //eslint-disable-next-line
  }, []);

  const { url, name, photo } = article;

  return (
    <ArticleRecommendationStyles>
      <div className="next-article__list-item">
        <h3 className="next-article__item-header">{header}</h3>
        <Link to={url}>
          <img
            src={photo.src}
            alt={photo.altText}
            className="next-article__img"
          />
          <p className="next-article__item-desc">{name}</p>
        </Link>
      </div>
    </ArticleRecommendationStyles>
  );
};

ArticleRecommendation.propTypes = {
  articles: PropTypes.object.isRequired,
  getArticle: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  articles: state.articles,
});

export default connect(mapStateToProps, { getArticle })(ArticleRecommendation);
